import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable, Signal } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { tapResponse } from '@ngrx/operators';
import { Observable, switchMap } from 'rxjs';
import { WIDGET_GLOBAL_DATA } from 'scw-digital-boards-widgets';
import { ELoadStatus } from '../../../state/state.interface';
import { IBaseResponse } from '../../../utilities/http-utilities.service';
import { TScwAppModules } from './scw-app-switcher.interface';

export interface IScwAppSwitcherComponentState {
  data: TScwAppModules;
  dataLoading: ELoadStatus;
}

@Injectable()
export class ScwAppSwitchersStore extends ComponentStore<IScwAppSwitcherComponentState> {
  private readonly oeeTrackerHttpContext: HttpContext = inject(WIDGET_GLOBAL_DATA).oeeTrackerHttpContext;

  readonly isLoading$: Signal<boolean> = this.selectSignal(
    (state: IScwAppSwitcherComponentState) => state.dataLoading === ELoadStatus.loading,
  );
  readonly data$: Signal<TScwAppModules> = this.selectSignal((state: IScwAppSwitcherComponentState) => state.data);

  readonly getUrls = this.effect((trigger$: Observable<void>) =>
    trigger$.pipe(
      switchMap(() => {
        this.patchState({ dataLoading: ELoadStatus.loading });

        return this.getUrlsFromOEE().pipe(
          tapResponse(
            (response) =>
              this.patchState({
                data: response.data,
                dataLoading: ELoadStatus.success,
              }),
            () => {
              this.patchState({ dataLoading: ELoadStatus.failure });
            },
          ),
        );
      }),
    ),
  );

  constructor(private readonly http: HttpClient) {
    super({
      data: {
        actionTracker: undefined,
        digitalBoards: undefined,
        digitalLogbook: undefined,
        oeeTracker: undefined,
      } as TScwAppModules,
      dataLoading: ELoadStatus.initial,
    });
  }

  private getUrlsFromOEE(): Observable<IBaseResponse<TScwAppModules>> {
    return this.http.get<IBaseResponse<TScwAppModules>>('users/scw-app-module-urls', {
      context: this.oeeTrackerHttpContext,
    });
  }
}
